export const ActionTypes = {
  SET_VIEW: 'SET_VIEW',
  ADD_EVENT: 'ADD_EVENT',
  SET_EVENTS: 'SET_EVENTS',
  SET_APPOINTMENTS: 'SET_APPOINTMENTS',
  UPDATE_EVENT: 'UPDATE_EVENT',
  MOVE_EVENT: 'MOVE_EVENT',
  DELETE_EVENT: 'DELETE_EVENT',
  SET_ACTIVE_EVENT: 'SET_ACTIVE_EVENT',
  SET_DATES: 'SET_DATES'
} as const;

export const CALENDAR_VIEW = {
  day: 'timeGridDay',
  week: 'timeGridWeek',
  month: 'dayGridMonth'
} as const;

export const CALENDAR_EVENT_STATUSES = {
  new: 'new',
  existing: 'existing'
} as const;

export const CALENDAR_EVENT_REPEATING = {
  no_repeat: 1,
  daily: 2,
  daily_weekdays: 3,
  weekly: 4
} as const;

export const CALENDAR_EVENT_TYPES = {
  appointment: 1,
  event: 2
} as const;
